import SuccessorResetPasswordPage from './successorResetPasswordPage';

export default SuccessorResetPasswordPage;